import _ from 'lodash';

const moduleName = 'SupervisionSignOffApproval';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
